import api from 'apis/restaurants';
import AppConfig from 'constants/AppConfig';
import { NotificationManager } from 'react-notifications';
import {
  GET_BRANCHES_SUPPLIERS,
  GET_RESTAURANTS_SUPPLIERS,
  GET_RESTAURANT_ADMIN_MANAGERS,
  GET_RESTAURANT_ADMIN_MANAGERS_FAILED,
  GET_RESTAURANT_BRANCHES,
  GET_RESTAURANT_BRANCHES_FAILED,
  GET_RESTAURANT_SUPPLIER_EMAILS,
  SET_ANOTHER_LOADING,
  SET_ANOTHER_PAGES_COUNT,
  SET_ANOTHER_PAGE_NUMBER,
  SET_ANOTHER_TOTAL_COUNT,
  SET_LOADING_STATUS,
  SET_PAGES_COUNT,
  SET_PAGE_NUMBER,
  SET_RESTAURANT,
  SET_RESTAURANT_FAILED,
  SET_TOTAL_COUNT,
} from 'redux/types';
import IntlMessages from 'utils/intl-messages';

export const getRestaurantById = (id, params, entity) => (dispatch) => {
  if (!entity) dispatch({ type: { SET_LOADING_STATUS }, payload: true });
  else dispatch({ type: SET_ANOTHER_LOADING, payload: true });
  api
    .getRestaurantById(id, params)
    .then((response) => {
      if (!entity) dispatch({ type: { SET_LOADING_STATUS }, payload: false });
      else dispatch({ type: SET_ANOTHER_LOADING, payload: false });
      dispatch({ type: SET_RESTAURANT, payload: response.data });
    })
    .catch(() => {
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      dispatch({ type: SET_RESTAURANT_FAILED });
      dispatch({ type: SET_ANOTHER_LOADING, payload: false });
    });
};

export const updateRestaurant = (restaurant) => (dispatch) => {
  dispatch({ type: SET_LOADING_STATUS, payload: true });
  return api
    .updateRestaurant(restaurant)
    .then((restaurant) => {
      dispatch({ type: SET_LOADING_STATUS, payload: false });
      return Promise.resolve(restaurant);
    })
    .catch((error) => {
      dispatch({ type: SET_LOADING_STATUS, payload: false });
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      return Promise.reject(error);
    });
};

export const getRestaurantSuppliers = (id, pagination, filters, sort, entity, join) => (dispatch) => {
  if (!entity) dispatch({ type: SET_LOADING_STATUS, payload: true });
  else dispatch({ type: SET_ANOTHER_LOADING, payload: true });
  api
    .getRestaurantSuppliers(id, { pagination, filters, sort, join })
    .then((response) => {
      dispatch({ type: GET_RESTAURANTS_SUPPLIERS, payload: response.data });
      dispatch({ type: SET_TOTAL_COUNT, payload: response.total });
      dispatch({ type: SET_PAGES_COUNT, payload: response.pageCount });
      dispatch({ type: SET_PAGE_NUMBER, payload: response.page });
      if (!entity) dispatch({ type: SET_LOADING_STATUS, payload: false });
      else dispatch({ type: SET_ANOTHER_LOADING, payload: false });
    })
    .catch(() => {
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      dispatch({ type: GET_RESTAURANTS_SUPPLIERS, payload: [] });
    });
};

export const setRestaurant = (value) => (dispatch) => {
  dispatch({ type: SET_RESTAURANT, payload: value });
};

export const getRestaurantAdminManagersUsers = (id, pagination, customParams) => (dispatch) => {
  dispatch({ type: SET_LOADING_STATUS, payload: true });
  api
    .getRestaurantAdminManagersUsers(id, { pagination, customParams })
    .then((response) => {
      dispatch({ type: GET_RESTAURANT_ADMIN_MANAGERS, payload: response.data });

      if (pagination) {
        dispatch({ type: SET_TOTAL_COUNT, payload: response.total });
        dispatch({ type: SET_PAGES_COUNT, payload: response.pageCount });
      }
    })
    .catch(() => {
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      dispatch({ type: GET_RESTAURANT_ADMIN_MANAGERS_FAILED });
    });
};

export const getRestaurantBranches =
  ({ pagination, filters, join, entity, sort }) =>
  (dispatch) => {
    if (!entity) dispatch({ type: SET_LOADING_STATUS, payload: true });
    else dispatch({ type: SET_ANOTHER_LOADING, payload: true });
    api
      .getRestaurantBranches({ pagination, filters, join, sort })
      .then((response) => {
        dispatch({ type: GET_RESTAURANT_BRANCHES, payload: response.data });
        if (!entity) {
          dispatch({ type: SET_TOTAL_COUNT, payload: response.total });
          dispatch({ type: SET_PAGES_COUNT, payload: response.pageCount });
          dispatch({ type: SET_PAGE_NUMBER, payload: response.page });
          dispatch({ type: SET_LOADING_STATUS, payload: false });
        } else {
          dispatch({ type: SET_ANOTHER_TOTAL_COUNT, payload: response.total });
          dispatch({ type: SET_ANOTHER_PAGES_COUNT, payload: response.pageCount });
          dispatch({ type: SET_ANOTHER_PAGE_NUMBER, payload: response.page });
          dispatch({ type: SET_ANOTHER_LOADING, payload: false });
        }
      })
      .catch(() => {
        NotificationManager.error(
          <IntlMessages id={`global.error.somethingWentWrong`} />,
          <IntlMessages id={`${AppConfig.errorTitle}`} />,
          AppConfig.errorNotificationTimeout
        );
        dispatch({ type: SET_LOADING_STATUS, payload: false });
        dispatch({ type: SET_ANOTHER_LOADING, payload: false });
        dispatch({ type: GET_RESTAURANT_BRANCHES_FAILED, payload: [] });
      });
  };

export const clearResBranches = () => (dispatch) => {
  dispatch({ type: GET_RESTAURANT_BRANCHES_FAILED });
};
export const clearResSuppliers = () => (dispatch) => {
  dispatch({ type: GET_RESTAURANTS_SUPPLIERS, payload: [] });
};

export const getRestaurantSupplierEmails = (restaurantId, supplierId) => (dispatch) => {
  dispatch({ type: SET_LOADING_STATUS, payload: true });
  api
    .getRestaurantSupplierEmails(restaurantId, supplierId)
    .then((response) => {
      dispatch({ type: GET_RESTAURANT_SUPPLIER_EMAILS, payload: response.data });
      dispatch({ type: SET_LOADING_STATUS, payload: false });
    })
    .catch(() => {
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      dispatch({ type: GET_RESTAURANT_SUPPLIER_EMAILS, payload: [] });
    });
};

export const onVerifyEmailCC = (restaurant) => (dispatch) => {
  dispatch({ type: SET_LOADING_STATUS, payload: true });
  return api
    .verifyEmailCC(restaurant)
    .then((restaurant) => {
      dispatch({ type: SET_LOADING_STATUS, payload: false });
      return Promise.resolve(restaurant);
    })
    .catch((error) => {
      dispatch({ type: SET_LOADING_STATUS, payload: false });
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      return Promise.reject(error);
    });
};

export const getBranchSuppliers = (id, pagination, filters, sort) => (dispatch) => {
  dispatch({ type: SET_LOADING_STATUS, payload: true });
  api
    .getBranchSuppliers(id, { pagination, filters, sort })
    .then((response) => {
      dispatch({ type: GET_BRANCHES_SUPPLIERS, payload: response.data });
      dispatch({ type: SET_TOTAL_COUNT, payload: response.total });
      dispatch({ type: SET_PAGES_COUNT, payload: response.pageCount });
      dispatch({ type: SET_PAGE_NUMBER, payload: response.page });
      dispatch({ type: SET_LOADING_STATUS, payload: false });
    })
    .catch(() => {
      NotificationManager.error(
        <IntlMessages id={`global.error.somethingWentWrong`} />,
        <IntlMessages id={`${AppConfig.errorTitle}`} />,
        AppConfig.errorNotificationTimeout
      );
      dispatch({ type: GET_BRANCHES_SUPPLIERS, payload: [] });
    });
};
